import api from '@/api';
import { CreateSaleResponse } from '@/types/api/sale';
import { CreateSaleRequest } from '@/types/api/sale/request';
import { ApiError } from '@/utils/shared/api.error';
import notify from '@/utils/shared/notify';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

type TData = CreateSaleResponse;
type TError = ApiError;
type TVariables = CreateSaleRequest;
type TContext = {};

export function useCreateSaleMutation(options?: UseMutationOptions<TData, TError, TVariables, TContext>) {
  const queryClient = useQueryClient();

  return useMutation<TData, TError, TVariables, TContext>({
    mutationKey: ['create-sale'],
    mutationFn: api.sale.create,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['sales'],
      });
    },
    onError: (error) => {
      let message = 'Försäljningen kunde inte skapas.';
      if (error.code === 'ACTIVE_SALE_EXISTS') message = 'En pågående försäljning finns redan.';
      notify.error(message);
    },
    ...options,
  });
}
